import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.company-registration', {
        url: '/companyRegistration',
        component: 'companyRegistration',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/company-registration/company-registration.state.js